let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gS3ma")).then(() => parcelRequire('gNcDN'));